import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : help with selections
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Button, Checkbox, Segment, Divider } from 'semantic-ui-react';
// ---Framework imports
import { callIfFunc } from 'ldash';
import { Sel } from 'uix/registries';
import log from 'uix/logging';
import { useSelector } from 'uix/hooks';
// ---Exports
// use with PopupItem
//~ <XMenu.PopupItem basic wide position="bottom left" icon="configure">
//~   <SelectSome available={known} active={activeTypes} setActive={setActiveTypes} />
//~ </XMenu.PopupItem>
export const SelectSome = ({ active = [], setActive, available = [], renderLabel })=>{
    let i18n = useSelector(Sel.i18n);
    let selected = active;
    let change = (name, value)=>{
        let nextSelected = [
            ...selected,
            name
        ];
        if (!value) {
            nextSelected = nextSelected.filter((n)=>n != name);
        }
        setActive(nextSelected);
    };
    let choices = available.map((name)=>/*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(Checkbox, {
                label: /*#__PURE__*/ _jsx("label", {
                    children: callIfFunc(renderLabel || name, name)
                }),
                checked: selected.includes(name),
                onChange: (e, data)=>change(name, data.checked)
            })
        }, name));
    return /*#__PURE__*/ _jsxs(Segment, {
        children: [
            choices,
            /*#__PURE__*/ _jsx(Divider, {
                fitted: true
            }),
            /*#__PURE__*/ _jsx(Button, {
                compact: true,
                basic: true,
                size: "mini",
                content: "Toggle",
                onClick: ()=>active.length ? setActive([]) : setActive(available)
            })
        ]
    });
};
